/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { object, oneOfType, func, element } from 'prop-types';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { SIGNUP_STATUS } from 'reducers/user';

/**
 * This is the ProtectedRoute component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export const ProtectedRoute = ({
  auth,
  user,
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      auth.isAuthenticated &&
      user.status === SIGNUP_STATUS.APPLICATION_APPROVED ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      )}
  />
);

ProtectedRoute.propTypes = {
  match: object.isRequired,
  location: object.isRequired,
  history: object.isRequired,
  auth: object.isRequired,
  user: object.isRequired,
  component: oneOfType([func, element]).isRequired,
};

export default withRouter(
  connect(({ auth, user }) => ({ auth, user }), {})(ProtectedRoute)
);
